
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react'

const ConfirmDialog = ({ texto, openDialog, setOpenDialog, identificador, rowId, handleResponse }) => {

    const handleClose = ({ respuesta = 'cancelar' }) => {
        //console.log(opcion);
        handleResponse(respuesta, rowId);
        setOpenDialog(false);
    };

    return (
        <Dialog
            open={openDialog}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <Box p={1}>
                <DialogTitle id="alert-dialog-title">
                    {"Confirmar acción"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {texto ? <p>{texto}</p> : ''}
                        <Box pl={4}>
                            {identificador ? <li >{identificador}</li> : ''}
                            <li>ID: {rowId}</li>
                        </Box>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' onClick={() => handleClose({ respuesta: 'cancelar' })}>Cancelar</Button>
                    <Button variant='contained' onClick={() => handleClose({ respuesta: 'aceptar' })} autoFocus>
                        Aceptar
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default ConfirmDialog